// Compre Junto da gaveta (GDB): carregado uma vez no header-actions,
// fora do bloco do carrinho, para funcionar mesmo quando a gaveta e
// re-renderizada (scripts injetados por morph nao executam).
import { CartAddEvent } from '@theme/events';
const gcjPasso = (row) => {
  const card = row.querySelector('[data-gcj-card]');
  return card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(row).columnGap || 0) : row.clientWidth;
};
if (!window.__gdbCartCj) {
  window.__gdbCartCj = true;
  // pontinhos + setas acompanham a rolagem (seta, dedo ou trackpad)
  document.addEventListener('scroll', (e) => {
    const row = e.target instanceof Element && e.target.matches('[data-gcj-row]') ? e.target : null;
    if (!row) return;
    const root = row.closest('[data-gcj]');
    const max = row.scrollWidth - row.clientWidth;
    const i = Math.round(row.scrollLeft / gcjPasso(row));
    root.querySelectorAll('.gdb-ccj__dot').forEach((d, k) => d.classList.toggle('is-on', k === i));
    const [prev, next] = root.querySelectorAll('[data-gcj-nav]');
    if (prev) prev.disabled = row.scrollLeft <= 2;
    if (next) next.disabled = row.scrollLeft >= max - 2;
  }, true);
  document.addEventListener('click', async (e) => {
    const nav = e.target.closest('[data-gcj-nav]');
    if (nav) {
      const row = nav.closest('[data-gcj]').querySelector('[data-gcj-row]');
      const passo = gcjPasso(row);
      const alvo = Math.round(row.scrollLeft / passo) + Number(nav.dataset.gcjNav);
      row.scrollTo({ left: Math.max(0, alvo) * passo, behavior: 'smooth' });
      return;
    }
    const open = e.target.closest('[data-gcj-open]');
    if (open) {
      const sizes = open.parentElement.querySelector('[data-gcj-sizes]');
      open.hidden = true;
      open.setAttribute('aria-expanded', 'true');
      sizes.hidden = false;
      sizes.querySelector('button:not(:disabled)')?.focus();
      return;
    }
    const btn = e.target.closest('[data-gcj-add]');
    if (!btn) return;
    const root = btn.closest('[data-gcj]');
    const card = btn.closest('[data-gcj-card]');
    const err = root.querySelector('[data-gcj-err]');
    err.hidden = true;
    const label = btn.textContent;
    card.classList.add('is-loading');
    btn.disabled = true;
    btn.textContent = btn.matches('.gdb-ccj__size') ? '...' : 'Adicionando...';
    try {
      const sections = [...document.querySelectorAll('cart-items-component')]
        .map((el) => el.dataset.sectionId)
        .filter(Boolean);
      const r = await fetch(root.dataset.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.gcjAdd, 10), quantity: 1 }], sections: sections.join(',') }),
      });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || 'Erro ao adicionar');
      document.dispatchEvent(
        new CartAddEvent({}, 'gdb-cart-cj', { source: 'gdb-cart-cj', itemCount: 1, sections: j.sections })
      );
    } catch (ex) {
      err.textContent = ex.message || 'Não foi possível adicionar. Tente novamente.';
      err.hidden = false;
      card.classList.remove('is-loading');
      btn.disabled = false;
      btn.textContent = label;
    }
  });
}
